import { hexToRGB } from "@shared/utils/misc";
import { css } from "styled-components";

export const toggleStyles = {
  wrapper: css<{ $disabled?: boolean }>`
    background: ${(p) => p.theme.colors.cardBgColor};
    border-radius: 6px;
    width: 100%;
    height: 32px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 2px;
    ${(p) =>
      p.$disabled &&
      `
    opacity: 0.5;
    cursor: not-allowed;
  `};
  `,
  option: css<{
    $selected: boolean;
    $disabled?: boolean;
    $isFirst?: boolean;
    $isLast?: boolean;
    $invalid?: boolean;
    $isValueSelected?: boolean;
  }>`
    font-size: ${(p) => p.theme.typography.fontSizes.S};
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: ${(p) => p.theme.colors.textColor};
    ${(props) =>
      props.$selected &&
      `
    background: ${hexToRGB(props.theme.colors.primaryBlue, 0.2)};
    color: ${props.theme.colors.primaryBlue};
    border-radius: 2px;
  `}
    ${(p) =>
      p.$isFirst &&
      `
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
    `}
    ${(p) =>
      p.$isLast &&
      `
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
    `}
    ${(p) =>
      !p.$isValueSelected &&
      `
    color: ${p.theme.colors.secondaryGrey}`};
    ${(p) =>
      p.$invalid &&
      `
    opacity: 0.2
  `}
  `,
};
